<script setup>
const props = defineProps({
    context: Object,
});

// console.log(props.context);

function handleInput(e) {
    console.log(e);
    props.context.node.input(e.target.value);
}
</script>

<template>
    <input @input="handleInput" :value="props.context._value" />
</template>
